import * as React from 'react';
import { ArrowRightIcon } from '@heroicons/react/outline';
import { Icon, Input, Textarea } from '@vechaiui/react';
import { useLocalization } from '@fluent/react';

import SingUpButtonGroupPage from './SignUpButtonGroupPage';
import StaticPageLayout from '#/layouts/StaticPageLayout';
import contactUsPageBg from '#/assets/static-page/contact_us_bg.png';
import mapIcon from '#/assets/static-page/map_icon.svg';
import wazeIcon from '#/assets/static-page/waze_icon.svg';

const ContactUsPage = () => {
  const { l10n } = useLocalization();
  const emailAddress = import.meta.env.VITE_COMPANY_CUSTOMER_SERVICE_ADDRESS;
  const adminEmailAddress = import.meta.env.VITE_COMPANY_ADMIN_ADDRESS;
  const companyContactNumber = import.meta.env.VITE_COMPANY_CONTACT_NUMBER;

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <StaticPageLayout>
      <div className="flex w-full space-x-10 bg-white">
        <div>
          <img src={contactUsPageBg} />
        </div>
        <div className="w-1/2 px-12 py-16">
          <h2 className="mb-10 text-black">{l10n.getString('contact-us')}</h2>
          <div className="flex flex-col mb-10 space-y-10">
            <div>
              <p className="text-gray-400">{l10n.getString('general-order-enquiries')}</p>
              <p>
                <a className="text-blue-500 underline" href={`mailto:${emailAddress}`}>
                  {emailAddress}
                </a>
              </p>
            </div>
            <div>
              <p className="text-black">
                Daily Move Sdn. Bhd. <br />
                Unit 120, Standard Chartered Building,
                <br />
                2 Beach Street, 10300 Georgetown, <br />
                Penang, Malaysia
              </p>
            </div>
            <div className="space-y-2">
              <p className="text-black">{companyContactNumber}</p>
              <p className="text-black">{adminEmailAddress}</p>
            </div>
            <div className="flex w-full">
              <div className="w-1/2 space-y-6 text-black">
                <p className="text-sm font-bold uppercase">Opening Hours</p>
                <p>
                  11am - 8pm
                  <br />
                  (Weekday)
                  <br />
                  First appointment: 11am
                  <br />
                  Last appointment: 6pm
                </p>
              </div>
              {/* <div className="space-y-6 text-black">
                <p className="text-sm font-bold uppercase">{l10n.getString('how-to-go')}</p>
                <div className="flex items-center space-x-3">
                  <div>
                    <img src={mapIcon} className="w-7" />
                  </div>
                  <a href="#" className="underline lowercase">
                    {l10n.getString('view-map')}
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <div>
                    <img src={wazeIcon} className="w-7" />
                  </div>
                  <a href="#" className="underline lowercase">
                    {l10n.getString('show-on-waze')}
                  </a>
                </div>
              </div> */}
            </div>
            {/* <div className="flex justify-end w-full">
              <div className="w-2/5"></div>
              <button className="flex items-center justify-between px-6 py-4 mt-5 text-black border border-blue-700 rounded-full w-72 hover:cursor-pointer">
                <div>Book an appointment</div>
                <Icon as={ArrowRightIcon} className="w-5" label="selector" />
              </button>
            </div> */}
            <div className="border-b border-neutral-400"></div>
            <div className="mt-5">
              <div className="text-2xl font-light text-black">
                Our Global Customer Experience team is available to receive your enquiries,
                questions and issues. Contact us today!
              </div>
              <div className="mt-10 space-y-3">
                <Input size="lg" placeholder="Full Name" className="border-0 bg-neutral-100" />
                <Input size="lg" placeholder="Email" className="border-0 bg-neutral-100" />
                <Input size="lg" placeholder="Subject" className="border-0 bg-neutral-100" />
                <Textarea size="lg" placeholder="Message" className="border-0 bg-neutral-100" />
              </div>
              <div className="flex justify-end w-full">
                <div className="w-2/5"></div>
                <button className="flex items-center justify-between px-5 py-4 mt-5 bg-blue-700 rounded-full w-72 hover:cursor-pointer">
                  <div className="text-white">{l10n.getString('submit-message')}</div>
                  <Icon as={ArrowRightIcon} className="w-5 text-white" label="selector" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <SingUpButtonGroupPage isBgBlue />
      </div>
    </StaticPageLayout>
  );
};

export default ContactUsPage;
